import * as React from "react";
import { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { alpha, Box, Grid, Skeleton } from "@mui/material";
import { ApiService } from "@/app/services/AppService";
import {
  BasicProgram,
  BasicProgramType,
  ResponseObject,
  ViewDetailsServices,
} from "@/app/classes/main";
import ViewDetails from "./ViewDetails";
import { CardRsOneService } from "../card/CardRsOneService";
import "./index.css";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface ViewDetailsRsOneContainerProps {
  open: any;
  handleCloseStoreDialog: any;
  viewDetailsRsOneSid: any;
}

interface ViewDetailsRsOne {
  ViewDetailsServices: ViewDetailsServices;
}

const ViewDetailsRsOneContainer: React.FC<ViewDetailsRsOneContainerProps> = ({
  open,
  handleCloseStoreDialog,
  viewDetailsRsOneSid,
}) => {
  const sid = viewDetailsRsOneSid ?? "";
  const [oneRsServiceData, setOneRsServiceData] = useState<
    ViewDetailsRsOne[] | undefined
  >(undefined);
  const apiService = React.useMemo(() => new ApiService(), []);
  const [openViewDetails, setOpenViewDetails] = useState(false);
  const [viewDetails, setViewDetails] = useState(new ViewDetailsServices());
  const [updateFlag, setUpdateFlag] = useState(false);
  const [updateCard, setUpdateCard] = useState(false);

  const handleViewDetails = (basicProgram: ViewDetailsServices) => {
    setOpenViewDetails(true);
    setUpdateFlag(true);
    setViewDetails(basicProgram);
  };

  const handleClose = () => {
    handleCloseStoreDialog();
    // setOneRsServiceData([]);
  };

  const getOneRsPackages = React.useCallback(async () => {
    try {
      if (sid) {
        const responseObject: ResponseObject | undefined =
          await apiService.get<ResponseObject>(
            apiService.getServicesInOneRs + "id=" + sid
          );
        const serviceDataOneRs = responseObject?.object;
        setOneRsServiceData(serviceDataOneRs);
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }, [apiService, sid]);

  useEffect(() => {
    getOneRsPackages();
  }, [sid, getOneRsPackages]);

  return (
    <React.Fragment>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        closeAfterTransition={false}
        PaperProps={{
          sx: {
            background:
              "linear-gradient(180deg, #fafdfb 0%, #ffffff 28%, #ffffff 100%)",
          },
        }}
      >
        <Box
          sx={{
            width: "-webkit-fill-available",
            textAlign: "end",
            padding: "0.5rem 0.5rem 0px 0px",
          }}
        >
          <IconButton
            onClick={handleClose}
            aria-label="Close"
            sx={{
              color: "#1f7a4d",
              bgcolor: alpha("#1f7a4d", 0.08),
              "&:hover": { bgcolor: alpha("#1f7a4d", 0.15) },
            }}
          >
            <CloseIcon sx={{ cursor: "pointer" }} />
          </IconButton>
        </Box>
        <Box
          sx={{
            background:
              "linear-gradient(135deg, #123524 0%, #1f7a4d 55%, #1a6b42 100%)",
            mx: { xs: 1.5, sm: 3 },
            borderRadius: "16px",
            boxShadow: "0 12px 40px rgba(18, 53, 36, 0.22)",
            py: { xs: 2, sm: 2.5 },
            px: 2,
          }}
        >
          <Box
            sx={{
              width: "100%",
              textAlign: "center",
              margin: "0rem auto",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                color: "#fff",
                padding: "0px 0.5rem",
                fontWeight: 800,
                letterSpacing: "-0.02em",
                fontSize: { xs: "15px", sm: "22px" },
                lineHeight: 1.35,
              }}
            >
              Choose any one service from below to avail the @Re. 1 service
              offer below!
            </Typography>
          </Box>
        </Box>
        <Grid
          container
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          sx={{
            background: "transparent",
            padding: {
              xs: "12px 8px 5rem",
              sm: "1rem 1rem 4rem",
              md: "2rem 2rem 4rem",
            },
            display: "flex",
            margin: "auto",
          }}
        >
          {oneRsServiceData && oneRsServiceData.length > 0
            ? oneRsServiceData &&
              oneRsServiceData?.map((item: any, index: any) => (
                <Grid container item xs={12} sm={6} md={4} lg={2.5} key={index}>
                  <CardRsOneService
                    childId={item?.id}
                    cid={item?.cid}
                    item={item}
                    viewDetailsData={() => handleViewDetails(item)}
                    updateCard={updateCard}
                    setUpdateCard={() => setUpdateCard(false)}
                  />
                </Grid>
              ))
            : Array.from({ length: 4 }).map((_, i) => (
                <Skeleton
                  key={i}
                  variant="rounded"
                  sx={{
                    margin: { xs: "0.5rem auto", sm: "1rem" },
                    width: { xs: "280px", sm: "280px", md: "280px" },
                    height: { xs: "280px", sm: "320px", md: "320px" },
                  }}
                />
              ))}
        </Grid>
      </Dialog>
      <ViewDetails
        open={openViewDetails}
        setClose={() => setOpenViewDetails(false)}
        id={viewDetails?.id}
        cid={viewDetails?.cid}
        imageUrl={
          viewDetails?.banner?.secureHttpPath ??
          viewDetails?.coverImage?.secureHttpPath
        }
        heading={viewDetails?.name}
        servicedDetails={viewDetails?.aboutList}
        descriptions={viewDetails?.descriptions}
        amount={viewDetails?.amount}
        min={viewDetails?.min}
        subHeading={viewDetails?.subHeading}
        mrp={viewDetails?.mrp}
        specialPrice={viewDetails?.specialPrice}
        specialMessage={viewDetails?.specialMessage}
        coin={viewDetails?.cashbackSalontymCoins}
        aboutList={viewDetails?.aboutList}
        serviceCharge={viewDetails?.serviceCharge}
        productCost={viewDetails?.productCost}
        reloadCartItemsFlag={() => setUpdateCard(true)}
        setReloadViewDetailsItem={() => setUpdateFlag(false)}
        reloadViewDetailsItem={updateFlag}
      />
    </React.Fragment>
  );
};

export default ViewDetailsRsOneContainer;
